export default {
  namespaced: true,
  state: {
    isMaintenance: false,
  },
  mutations: {
    setMaintenance(state, value) {
      state.isMaintenance = value
    },
  },
  actions: {
    enable({ commit }) { commit('setMaintenance', true) },
    disable({ commit }) { commit('setMaintenance', false) },
  },
}
